"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _helpers = require("./helpers");

var _styler = _interopRequireDefault(require("../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Options = function Options(_ref) {
  var children = _ref.children,
      truncated = _ref.truncated;
  return _react.default.createElement(_styler.default, {
    classNames: "co-heading__options",
    modifiers: {
      truncated: truncated
    }
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, (0, _helpers.truncateChildren)(children, truncated));
  });
};

Options.propTypes = {
  children: _propTypes.any.isRequired,
  truncated: _propTypes.bool
};
Options.displayName = 'Header.Options';
var _default = Options;
exports.default = _default;
Options.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Header.Options",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": ""
    },
    "truncated": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};